import { type RefObject, useEffect } from "react";

interface UseClipboardPasteOptions {
  onImagePaste: (file: File) => void;
  containerRef?: RefObject<HTMLElement>;
}

/**
 * クリップボードから画像を貼り付けるためのカスタムフック
 *
 * @param onImagePaste - 画像ファイルが貼り付けられたときに呼ばれるコールバック
 * @param containerRef - イベントリスナーを追加する要素のRef（指定しない場合はdocument全体）
 */
export function useClipboardPaste({
  onImagePaste,
  containerRef,
}: UseClipboardPasteOptions): void {
  useEffect(() => {
    const handlePaste = (e: ClipboardEvent): void => {
      const items = e.clipboardData?.items;
      if (!items) return;

      // クリップボードのアイテムから画像を探す
      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        // 画像タイプのアイテムをチェック
        if (item.type.startsWith("image/")) {
          e.preventDefault();

          const file = item.getAsFile();
          if (file) {
            onImagePaste(file);
          }
          break;
        }
      }
    };

    const target = containerRef?.current || document;
    target.addEventListener("paste", handlePaste as EventListener);

    return (): void => {
      target.removeEventListener("paste", handlePaste as EventListener);
    };
  }, [onImagePaste, containerRef]);
}
